import type { ConsumerViewParams } from '../types/consumer.types';

export const buildUrlParams = (params: ConsumerViewParams): string => {
  const urlParams = new URLSearchParams();

  urlParams.append('startDate', params.startDate);
  urlParams.append('endDate', params.endDate);

  if (params.companies.length > 0) {
    urlParams.append('companies', JSON.stringify(params.companies));
  }

  if (params.cups.length > 0) {
    urlParams.append('cups', JSON.stringify(params.cups));
  }

  return urlParams.toString();
};
